import { CALL_API } from "admin/middlewares/api";

export const BORROWER_TERMS_GET_REQUEST = "BORROWER_TERMS_GET_REQUEST";
export const BORROWER_TERMS_GET_SUCCESS = "BORROWER_TERMS_GET_SUCCESS";
export const BORROWER_TERMS_GET_ERROR = "BORROWER_TERMS_GET_ERROR";

export function get_borrower_terms() {
  let uri = "/api/admin/loanstep/borrower-terms";

  return {
    [CALL_API]: {
      method: "GET",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        BORROWER_TERMS_GET_REQUEST,
        BORROWER_TERMS_GET_SUCCESS,
        BORROWER_TERMS_GET_ERROR,
      ],
    },
  };
}

export const LENDER_TERMS_GET_REQUEST = "LENDER_TERMS_GET_REQUEST";
export const LENDER_TERMS_GET_SUCCESS = "LENDER_TERMS_GET_SUCCESS";
export const LENDER_TERMS_GET_ERROR = "LENDER_TERMS_GET_ERROR";

export function get_lender_terms() {
  let uri = "/api/admin/savelend/lender-terms";

  return {
    [CALL_API]: {
      method: "GET",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        LENDER_TERMS_GET_REQUEST,
        LENDER_TERMS_GET_SUCCESS,
        LENDER_TERMS_GET_ERROR,
      ],
    },
  };
}

export const LOANSTEP_GENERAL_TERMS_GET_REQUEST =
  "LOANSTEP_GENERAL_TERMS_GET_REQUEST";
export const LOANSTEP_GENERAL_TERMS_GET_SUCCESS =
  "LOANSTEP_GENERAL_TERMS_GET_SUCCESS";
export const LOANSTEP_GENERAL_TERMS_GET_ERROR =
  "LOANSTEP_GENERAL_TERMS_GET_ERROR";

export function get_loanstep_general_terms() {
  let uri = "/api/admin/loanstep/general-terms";

  return {
    [CALL_API]: {
      method: "GET",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        LOANSTEP_GENERAL_TERMS_GET_REQUEST,
        LOANSTEP_GENERAL_TERMS_GET_SUCCESS,
        LOANSTEP_GENERAL_TERMS_GET_ERROR,
      ],
    },
  };
}

export const SAVELEND_GENERAL_TERMS_GET_REQUEST =
  "SAVELEND_GENERAL_TERMS_GET_REQUEST";
export const SAVELEND_GENERAL_TERMS_GET_SUCCESS =
  "SAVELEND_GENERAL_TERMS_GET_SUCCESS";
export const SAVELEND_GENERAL_TERMS_GET_ERROR =
  "SAVELEND_GENERAL_TERMS_GET_ERROR";

export function get_savelend_general_terms() {
  let uri = "/api/admin/savelend/general-terms";

  return {
    [CALL_API]: {
      method: "GET",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        SAVELEND_GENERAL_TERMS_GET_REQUEST,
        SAVELEND_GENERAL_TERMS_GET_SUCCESS,
        SAVELEND_GENERAL_TERMS_GET_ERROR,
      ],
    },
  };
}

export const PAYMENT_SERVICE_TERMS_GET_REQUEST =
  "PAYMENT_SERVICE_TERMS_GET_REQUEST";
export const PAYMENT_SERVICE_TERMS_GET_SUCCESS =
  "PAYMENT_SERVICE_TERMS_GET_SUCCESS";
export const PAYMENT_SERVICE_TERMS_GET_ERROR =
  "PAYMENT_SERVICE_TERMS_GET_ERROR";

export function get_payment_service_terms() {
  let uri = "/api/admin/savelend/payment-service-terms";

  return {
    [CALL_API]: {
      method: "GET",
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        PAYMENT_SERVICE_TERMS_GET_REQUEST,
        PAYMENT_SERVICE_TERMS_GET_SUCCESS,
        PAYMENT_SERVICE_TERMS_GET_ERROR,
      ],
    },
  };
}

export const BORROWER_TERMS_SEND_REQUEST = "BORROWER_TERMS_SEND_REQUEST";
export const BORROWER_TERMS_SEND_SUCCESS = "BORROWER_TERMS_SEND_SUCCESS";
export const BORROWER_TERMS_SEND_ERROR = "BORROWER_TERMS_SEND_ERROR";

export function send_borrower_terms(content, version, isUpdating) {
  const uri = !isUpdating
    ? "/api/admin/loanstep/set-borrower-terms"
    : "/api/admin/loanstep/update-borrower-terms-without-versioning";
  const data = !isUpdating
    ? { ExpectedVersion: version, Terms: content, Type: "Borrower" }
    : {
        TermsContent: content,
        Type: "Borrower",
        ExpectedCurrentVersion: version,
      };

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        BORROWER_TERMS_SEND_REQUEST,
        BORROWER_TERMS_SEND_SUCCESS,
        BORROWER_TERMS_SEND_ERROR,
      ],
    },
  };
}

export const GENERAL_TERMS_SEND_REQUEST = "GENERAL_TERMS_SEND_REQUEST";
export const GENERAL_TERMS_SEND_SUCCESS = "GENERAL_TERMS_SEND_SUCCESS";
export const GENERAL_TERMS_SEND_ERROR = "GENERAL_TERMS_SEND_ERROR";

export function send_general_terms(contents, version, isUpdating) {
  const uri = !isUpdating
    ? "/api/admin/savelend/set-general-terms"
    : "/api/admin/savelend/update-general-terms-without-versioning";
  const data = {
    TermsContentEN: contents.EN,
    TermsContentSE: contents.SE,
    TermsContentFI: contents.FI,
    ExpectedCurrentVersion: version,
  };

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        GENERAL_TERMS_SEND_REQUEST,
        GENERAL_TERMS_SEND_SUCCESS,
        GENERAL_TERMS_SEND_ERROR,
      ],
    },
  };
}

export const LOANSTEP_GENERAL_TERMS_SEND_REQUEST =
  "LOANSTEP_GENERAL_TERMS_SEND_REQUEST";
export const LOANSTEP_GENERAL_TERMS_SEND_SUCCESS =
  "LOANSTEP_GENERAL_TERMS_SEND_SUCCESS";
export const LOANSTEP_GENERAL_TERMS_SEND_ERROR =
  "LOANSTEP_GENERAL_TERMS_SEND_ERROR";

export function send_ls_general_terms(content, version, isUpdating) {
  const uri = !isUpdating
    ? "/api/admin/loanstep/set-general-terms"
    : "/api/admin/loanstep/update-general-terms-without-versioning";
  const data = !isUpdating
    ? { ExpectedVersion: version, Terms: content, Type: "General" }
    : {
        TermsContent: content,
        Type: "General",
        ExpectedCurrentVersion: version,
      };

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        LOANSTEP_GENERAL_TERMS_SEND_REQUEST,
        LOANSTEP_GENERAL_TERMS_SEND_SUCCESS,
        LOANSTEP_GENERAL_TERMS_SEND_ERROR,
      ],
    },
  };
}

export const LENDER_TERMS_SEND_REQUEST = "LENDER_TERMS_SEND_REQUEST";
export const LENDER_TERMS_SEND_SUCCESS = "LENDER_TERMS_SEND_SUCCESS";
export const LENDER_TERMS_SEND_ERROR = "LENDER_TERMS_SEND_ERROR";

export function send_lender_terms(contents, version, isUpdating) {
  const uri = !isUpdating
    ? "/api/admin/savelend/set-lender-terms"
    : "/api/admin/savelend/update-lender-terms-without-versioning";
  const data = {
    TermsContentEN: contents.EN,
    TermsContentSE: contents.SE,
    TermsContentFI: contents.FI,
    ExpectedCurrentVersion: version,
  };

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        LENDER_TERMS_SEND_REQUEST,
        LENDER_TERMS_SEND_SUCCESS,
        LENDER_TERMS_SEND_ERROR,
      ],
    },
  };
}

export const PAYMENT_SERVICE_TERMS_SEND_REQUEST =
  "PAYMENT_SERVICE_TERMS_SEND_REQUEST";
export const PAYMENT_SERVICE_TERMS_SEND_SUCCESS =
  "PAYMENT_SERVICE_TERMS_SEND_SUCCESS";
export const PAYMENT_SERVICE_TERMS_SEND_ERROR =
  "PAYMENT_SERVICE_TERMS_SEND_ERROR";

export function send_payment_service_terms(contents, version, isUpdating) {
  const uri = !isUpdating
    ? "/api/admin/savelend/set-payment-service-terms"
    : "/api/admin/savelend/update-payment-service-terms-without-versioning";
  const data = {
    TermsContentEN: contents.EN,
    TermsContentSE: contents.SE,
    TermsContentFI: contents.FI,
    ExpectedCurrentVersion: version,
  };

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        PAYMENT_SERVICE_TERMS_SEND_REQUEST,
        PAYMENT_SERVICE_TERMS_SEND_SUCCESS,
        PAYMENT_SERVICE_TERMS_SEND_ERROR,
      ],
    },
  };
}
